module.exports = __webpack_public_path__ + "media/images/icons/wallet_icon-3b572284f45634e5478da5b7230d966b.svg";